import type { GetCourseDraftsFilter } from './getCourseDraftsFilter';

export type GetCourseDraftsParams = {
/**
 * 페이지 번호 (0부터 시작)
 */
page?: number;
/**
 * 페이지 크기
 */
size?: number;
/**
 * 목록 필터링 조건
- `my_drafts`: 현재 사용자의 초안만

 */
filter?: GetCourseDraftsFilter;
};
